import CatalogSeoPage from './CatalogSeoPage';

export default CatalogSeoPage;
